import { Component, OnInit, Input, OnDestroy, Inject, AfterViewInit } from '@angular/core';

import * as Services from '@shared/core/services';
import { Controllers } from '@shared/core/controllers';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { ISubNavPage } from '@shared/core/components/subNav';
import * as Tokens from '@shared/core/tokens';
@Component({
    template: '<div>This component requires extending</div>'
})
export class OnlineMenuNavTypesComponent implements OnInit, OnDestroy, AfterViewInit {
    private _isOpen: boolean = false;

    @Input() public registryId: string = 'locationDetails';
    @Input() public delayScroll: number = null;

    public hasScrolled$: Observable<boolean>;
    public searchTerm$: Observable<string>;
    public onlineMenuPages$!: Observable<APICommon.IOnlineMenuPageResponseModel[]>;

    constructor(
        public controllers: Controllers,
        public drawCollapseService: Services.DrawCollapseService,
        public subNavService: Services.SubNavService,
        private _modalsService: Services.ModalsService,
        @Inject(Tokens.CONFIG_TOKEN) private _config: IConfig,
    ) { }

    ngOnInit(): void {
        this.onlineMenuPages$ = this.controllers.onlineMenu.onlineMenuPagesFiltered$();
        this.searchTerm$ = this.controllers.filters.getOnlineMenuFiltersSearchTerm$();
        this.hasScrolled$ = this.drawCollapseService.drawProgress$
            .pipe(
                map(val => val < .5)
            );
    }

    ngAfterViewInit(): void {
        if (this._config.showCategoriesOnInitInMobileView && this.isMobile) {
            this.showCategoriesOnInitInMobileView();
        }
    }

    ngOnDestroy(): void {
        this._bodyScrollLock(false);
    }

    private showCategoriesOnInitInMobileView(): void {
        this._modalsService.modalsList$.pipe(
            filter(modalsList => !modalsList.length),
            take(1),
        ).subscribe(() => {
            this.handleSearchToggle(true);
        });
    }

    private _bodyScrollLock(lock: boolean): void {
        if (lock) {
            document.body.style.height = '100vh';
            document.body.style.overflow = null;
        } else {
            document.body.style.height = null;
            document.body.style.overflow = null;
        }
    }

    public handleSearchToggle(isOpen: boolean): void {
        this._isOpen = isOpen;

        if (this.isMobile) {
            this._bodyScrollLock(this._isOpen === true);

            if (this._isOpen) {
                this.drawCollapseService.toggleDraw(false);
                setTimeout(() => {
                    this.subNavService.forceHeightUpdate();
                }, 500);
            } else {
                this.drawCollapseService.toggleDraw(true);
            }
        }
    }

    public handleCategoryClick($event: Event): void {
        this.handleSearchToggle(false);
    }

    public handlePageClick(page: ISubNavPage): void {
        this.subNavService.setCurrent(this.registryId, page.Id);
    }

    public handleBackClick($event: Event): void {
        this.controllers.routes.navigateToLocationsSearchView();
    }

    public get isOpen(): boolean {
        return this._isOpen;
    }

    public get isMobile(): boolean {
        return window.innerWidth < 768;
    }
}
